// Get header DOM element
const header = document.getElementById( 'masthead' );

function toggleHeaderBackground() {
	// Get the current Y scroll position
	const scrollY = window.scrollY;

	// Check if the page has scrolled more than 100px
	// if it has add a class, otherwise remove the class
	if ( scrollY > 100 ) {
		header.classList.add( 'site-header--scrolled' );
	} else {
		header.classList.remove( 'site-header--scrolled' );
	}
}

// Set up an event listener for scroll events and run the function to toggle
window.addEventListener( 'scroll', toggleHeaderBackground );
